import { Flex } from '@chakra-ui/react';
import { Clock, BarChart3 } from 'lucide-react';
import { ActionButtonWithBadge } from './ActionButtonWithBadge';

interface HourRequestsTasksBarProps {
  hourRequestsCount: number;
  tasksCount: number;
  onOpenHourRequests: () => void;
  onOpenTasks: () => void;
}

export function HourRequestsTasksBar({
  hourRequestsCount,
  tasksCount,
  onOpenHourRequests,
  onOpenTasks,
}: HourRequestsTasksBarProps) {
  return (
    <Flex gap="2" mb="4" flexDirection="row" flexWrap="wrap">
      <ActionButtonWithBadge
        label="Hour Requests"
        icon={Clock}
        badgeCount={hourRequestsCount}
        onClick={onOpenHourRequests}
      />
      <ActionButtonWithBadge
        label="Tasks"
        icon={BarChart3}
        badgeCount={tasksCount}
        onClick={onOpenTasks}
      />
    </Flex>
  );
}
